<template>
  <div class="supplierTrain">
    <div class="nav">
      <el-form :model="form" label-width="80px" :inline="true"  class="demo-form-inline flex1">
        <el-form-item label="供应商:">
          <el-input v-model="form.supplierName" size="mini" placeholder="请输入供应商名称"></el-input>
        </el-form-item>
        <el-form-item label="培训方式:">
          <el-input v-model="form.trainMode" size="mini" placeholder="请输入培训方式"></el-input>
        </el-form-item>
        <el-form-item label="培训时间:">
          <el-date-picker v-model="form.time[0]" size="mini" style="width:150px" value-format="yyyy-MM-dd" @change="dateChange" type="date" placeholder="开始日期"/>
          <span style="display:inline-block;width:15px;text-align:center;font-size:18px">-</span>
          <el-date-picker v-model="form.time[1]" size="mini" style="width:150px" value-format="yyyy-MM-dd" @change="dateChange" type="date" placeholder="结束日期"/>
        </el-form-item>

        <el-form-item label="状态:">
          <el-select v-model="form.status" filterable size="mini" placeholder="请选择状态">
            <el-option label="全部" value=""></el-option>
            <el-option label="待审核" value="1"></el-option>
            <el-option label="已通过" value="2"></el-option>
            <el-option label="已拒绝" value="3"></el-option>
            <el-option label="已取消" value="4"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item>
          <el-button size="small" class="searchBtn" @click="searchBtn">查询</el-button>
          <el-button size="small" class="resetBtn" @click="resetBtn">重置</el-button>
        </el-form-item>

      </el-form>
    </div>
    <div class="content">
      <div class="tableContainer">
        <el-table
          v-loading="tableLoad"
          :data="TableDatas"
          style="width: 100%"
          border
          stripe
          :header-cell-style="{color:'#3B3B3B','font-size':'13px','height':'48px',background:'#E8E8E8'}"
          :cell-style="{'color':'#7F7F7F','font-size':'13px','height':'52px',}"
        >
          <el-table-column label="序号" type="index" :index="tableIndexMethod" align="center" width="50px">

          </el-table-column>
          <el-table-column prop="supplierName" label="供应商" align="center"/>
          <el-table-column prop="trainMode" label="培训方式" align="center"/>
          <el-table-column prop="trainTime" label="培训时间" align="center"/>
          <el-table-column prop="trainSite" label="培训地点" align="center"/>
          <el-table-column prop="createTime" label="添加时间" align="center">
            <template slot-scope="scope">
              {{scope.row.createTime | formatTime}}
            </template>
          </el-table-column>
          <el-table-column prop="stateStr" label="状态" align="center"/>
          <el-table-column label="操作" width="250" align="center">
            <template slot-scope="scope">
              <div style="display:flex;align-items:center;padding-left: 10px">
                <el-button size="mini" class="searchBtn" type="primary" @click="detailClick(scope.row)">详情</el-button>
                <el-button size="mini" type="danger" @click="refuseClick(scope.row,0)">同意</el-button>
                <el-button size="mini" type="danger" @click="refuseClick(scope.row,-1)">拒绝</el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="paginationContainer">
        <el-pagination
          background
          :page-sizes="[10, 20, 30, 40]"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          @size-change="contractSizeChange"
          @current-change="contractCurrentChange"
          :current-page.sync="form.page"
          :page-size="form.rows"
        />
      </div>
    </div>

    <el-dialog title="详情" :visible.sync="detailDialogVisible" width='623px' center :close-on-click-modal="false">
      <div class="detail">
        <div class="baseInfo">

            <div class="baseInfoTitle">
              <div class="line"/>
              <span>基础信息</span>
              <p :style="getStyle(detailData.state)">{{detailData.stateStr}}</p>
            </div>
            <div class="baseInfoContent">
              <el-form :model="detailData"  label-position="left">
                <el-form-item label="培训时间:">
                  <span>{{detailData.trainTime}}</span>
                </el-form-item>
                <el-form-item label="培训方式:">
                  <span>{{detailData.trainMode}}</span>
                </el-form-item>
                <el-form-item label="培训地点:">
                  <span>{{detailData.trainSite}}</span>
                </el-form-item>
                <el-form-item label="培训内容:">
                  <span>{{detailData.trainContent}}</span>
                </el-form-item>
                <el-form-item label="培训原因:">
                  <span>{{detailData.trainReason}}</span>
                </el-form-item>
                <el-form-item label="培训供应商:">
                  <span>{{detailData.supplierName}}</span>
                </el-form-item>
                <el-form-item label="我司培训人员:">
                  <span>{{detailData.empName}}</span>
                </el-form-item>
              </el-form>

            </div>
            <div class="operation">
              <div class="operationTitle">
                <div class="line"/>
                <span>审核信息</span>
              </div>
              <div class="operationTable">
                <steps :step-data="stepData" :step-state="stepState"/>
              </div>
              <div class="operationTitle">
                <div class="line"/>
                <span>操作</span>
              </div>
              <div class="operationTable" >
                <el-form ref="detailRemark" label-width="80px" :rules="rules" :model="params">
                  <el-form-item label="原因"  prop="auditOpinion">
                    <el-input size="mini" placeholder="请填写同意/拒绝原因" :autosize="{ minRows: 5, maxRows: 10}"
                              style="width:80% "
                              v-model="params.auditOpinion"
                              type="textarea"></el-input>
                  </el-form-item>
                  <el-form-item style="display: flex;justify-content: space-between;">
                    <el-button type="primary" size="medium" @click="remarkAgree(0)">确认</el-button>
                    <el-button type="danger" size="medium" @click="remarkAgree(-1)">拒绝</el-button>
                  </el-form-item>
                </el-form>

              </div>
            </div>

        </div>


      </div>

    </el-dialog>
  </div>
</template>

<script>
  import {
    baseUrl,
    baseImgUrl
  } from "@/config/env";

  import divBorder from "@/components/divBorder";
  import steps from "@/components/steps";
  import {
    formatTime
  } from "@/config/mUtils";

  import {
    empDeptListByEmpName,
    auditPageListPageList,
    trainRecordReviewSubmit,
    trainRecordDetail
  }from "@/service/audit"
  export default {
    components: {
      divBorder,
      steps
    },

    data() {

      return {
        form:{
          supplierName:"",
          trainMode:"",
          time:['',''],
          status:"",
          page:1,
          rows:10,
        },
        total:0,
        tableLoad:false,
        TableDatas:[

        ],

        detailDialogVisible:false,
        detailData:{

        },
        stepData:[
          {title:'张三发起',time:'2021-9-30 14:09:23',state:'',remark:''},
          {title:'财务部 张三通过',time:'2021-9-30 14:09:23',state:'success',remark:'原因xxxxxx'},
          {title:'技术部 李四拒绝',time:'2021-9-30 14:09:23',state:'failure',remark:'原因xxxxxx'},
          {title:'张三重新发起',time:'2021-9-30 14:09:23',state:'',remark:''},
        ],
        operationData:[
          {operateTime:'2021-8-31 15:49:58',operateType:'启用',account:'王三文',remark:'',size: 'large',},
          {operateTime:'2021-8-31 15:49:58',operateType:'禁用',account:'张三丰',remark:''},
          {operateTime:'2021-8-31 15:49:58',operateType:'添加',account:'赵兮雪',remark:''},
        ],
        dialogVisible:false,
        params:{
          auditOpinion:'',
        },
        rules:{
          auditOpinion:{ required: true, message: '请填写同意/拒绝原因', trigger: 'blur' },
        },



        cascaderMap: new Map(),

      };

    },
    filters:{
      stats(val){
        let text=''
        switch (val) {
          case 1:
            text='待审核'
            break;
          case 2:
            text='已通过'
            break;
          case 3:
            text='已拒绝'
            break;
          case 4:
            text='已取消'
            break;
        }
        return text
      },
      formatTime(val){
        if(val){
          return formatTime(val, "yyyy-mm-dd hh:ii:ss")
        }else {
          return ''
        }

      }
    },
    computed:{
      getStyle() {
        return (val) => {
          switch (val) {
            case 2:
              return 'color: rgba(51, 136, 255, 1);'
            case 1:
              return 'color: rgba(249, 166, 6, 1)'
            case 3:
              return 'color:#F56C6C;'
            case 4:
              return 'color:#F56C6C;'
          }
        }
      },
      stepState(){
        return function(state){
          switch(state) {
            case '':
              return 'wait'
            case 'success':
              return 'success'
            case 'failure':
              return 'error'
          }
        };
      },
    },
    created() {
      this.$nextTick(()=>{
        this.init()
      })
    },
    methods: {
      init(){
        this.uploadUrl = baseUrl + "/web/attachment/upload";
        this._trainRecordPageList()
      },
      async _trainRecordPageList(){
        let {
          time,
          status
        } = this.form
        this.tableLoad = true;
        let res = await  auditPageListPageList({
          ...this.form,
          state:status,
          startDate:time[0],
          endDate:time[1]
        })
        this.tableLoad = false
        if (res.status !==0){
          return  this.$message.error(res.message)
        }
        this.TableDatas = res.data.records
        this.total = res.data.total
      },
      // 结束时间
      dateChange(val) {
        if(this.form.time[1]&&this.form.time[0]&&(this.form.time[1] < this.form.time[0])) {
          if(val == this.form.time[1]) this.form.time[1] = '';
          if(val == this.form.time[0]) this.form.time[0] = '';
        this.$forceUpdate();
          return this.$message.warning("结束日期必须大于开始日期！");
        }
      },
      searchBtn(){
        this.form.page = 1;
        this._trainRecordPageList()
      },
      resetBtn(){
        for (const argumentsKey in this.form) {
          this.form[argumentsKey] = ""
        }
        this.form.time = ['',''];
        this.form.page = 1
        this.form.rows = 10

      },
      contractSizeChange(row){
        this.form.rows=row;
        this._trainRecordPageList()
      },
      contractCurrentChange(page){
        this.form.page=page;
        this._trainRecordPageList()
      },
      tableIndexMethod(index) {
        return this.form.rows * (this.form.page - 1) + index + 1;
      },
      // 详情
      async detailClick(row){
        this.detailDialogVisible = true
        let res =await trainRecordDetail(row)
        if (res.status !==0) return  this.$message.error(res.message)
        this.detailData =res.data
        this.detailData.empName=''
        let {compTrainParticipatorList} =res.data
        compTrainParticipatorList.forEach((item,index)=>{
          this.detailData.empName += compTrainParticipatorList.length -1 ===index ? item.empName :item.empName +","
        })

      },

      refuseClick(row,flag){
        this.$prompt(`确认要${flag===0 ? '同意':'拒绝'}培训计划申请吗？`, "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
          inputType: "textarea",

        }).then(async ({value}) => {
            let thisID = row.id;
          // AGREE同意，REFUSE拒绝
            let params = {
              reviewResult:flag ===0 ?"AGREE":"REFUSE",
              id:thisID,
              auditOpinion:value
            }
            let res = await trainRecordReviewSubmit(params);

            if (res.status !== 0)  return this.$message.error(res.message);
            this.$message.success(res.message);
            await this._trainRecordPageList()



          }).catch(() => {});
      },
      closeDialog(){
        this.dialogVisible = false
      },

      arraySpanMethod({ row, column, rowIndex, columnIndex }){
        if (columnIndex === 0) {
          if (rowIndex % 2 === 0) {
            return {
              rowspan: 2,
              colspan: 1
            };
          } else {
            return {
              rowspan: 0,
              colspan: 0
            };
          }
        }
      },


      handleChange(index){
        // arr = this.$refs.areaCascader.currentLabels;
        // console.log(this.$refs.areaCascader)
        console.log(index)
      },
      remarkAgree(flag){
        this.$refs.detailRemark.validate(async (valid) => {
          if (valid) {
            // AGREE同意，REFUSE拒绝

            let  params = {
              id:this.detailData.id,
              reviewResult:flag ===0 ?"AGREE":"REFUSE",
              auditOpinion:this.params.auditOpinion

            }
            let res = await trainRecordReviewSubmit(params);

            if (res.status !== 0)  return this.$message.error(res.message);
            this.$message.success(res.message);
            this.detailDialogVisible = false
            await this._trainRecordPageList()


          }else {
            return false;
          }

        })


      }


    },
  };
</script>



<style lang="scss" scoped>
  .supplierTrain{
    /*width:100%;*/
    padding:20px 15px 0 25px;
    height: 100%;
    /*overflow: auto;*/
    .nav{
      /*width:100%;*/
      display: flex;
      /*align-items: center;*/
      /*height:30px;*/
      overflow: hidden;
      .flex1{
        flex: 1;
      }
      .el-input{
        width: 150px;
      }
      .el-select{
        width: 150px;
      }
      ::v-deep {
        label.el-form-item__label {
          font-weight: 500;
          color: #101010;
        }
      }
    }
    .content{
      .tableContainer{
        margin-bottom: 25px;
        ::v-deep{
          .el-table .cell {
            padding: 0;
          }
          .el-table th{
            padding: 0;
          }
          .el-table td{
            padding: 0;
          }
          .el-table th>.cell{
            font-weight: 700!important;
          }
        }
      }
    }
    ::v-deep .detail{

      .line{
        width: 12px;
        height: 32px;
        background-color: rgba(51, 84, 131, 100);
        margin-right: 10px;
      }
      .line +span{
        font-size: 16px;
        color: rgba(51, 84, 131, 100);
        font-weight: 600;
      }
      width: 100%;
      padding: 10px 0 20px 20px;
      .baseInfo{
        display: flex;
        flex-direction: column;
        &Title{
          display:flex;
          align-items:flex-end;
          p{
            font-weight: 700;
            font-size: 14px;
            color: rgba(249, 166, 6);
            margin-left: 10px;
          }
        }
        .el-form-item__label{
          /*color: #060606;*/
          font-weight: 700;
        }
        &Content{
          display:flex;
          flex-direction: column;
          justify-content: space-between;
          padding:20px 23px 0 23px;
          font-size: 14px;
          .center-f{
            display: flex;
          }
          .el-form-item{
            margin-bottom: 2px;

          }


        }
      }
      .operation{
        display: flex;
        flex-direction: column;
        &Title{
          display:flex;
          align-items:flex-end;
          p{
            font-weight: 700;
            font-size: 14px;
            color: rgba(51, 136, 255, 1);
            margin-left: 10px;
          }
        }
        &Table{
          width:100%;
          margin-top: 10px;
          padding-right: 20px;
        }
      }
    }
    ::v-deep .add{

      .el-form-item__label{
        font-weight: 700;
      }
      .line{
        width: 12px;
        height: 32px;
        background-color: rgba(51, 84, 131, 100);
        margin-right: 10px;
      }
      .line +span{
        font-size: 16px;
        color: rgba(51, 84, 131, 100);
        font-weight: 600;
      }
      width: 100%;

      .baseInfo{
        display: flex;
        flex-direction: column;

        &Content{
          display:flex;
          flex-direction: column;
          justify-content: space-between;
          padding:20px 23px 0 23px;
          font-size: 14px;
          .yang{
            .el-form-item{
              .el-form-item__error{
                left: 40px;
              }
              margin-bottom:15px;

              .el-form-item__label{
                width: 150px !important;
                /*color: #060606;*/
              }
              .el-input{
                width: 430px;
              }
              .el-textarea{
                width: 430px;

              }
            }

          }


        }
        .tablesConter{
          .el-form-item{
            margin: 16px 7px;
          }
        }
        .append{
          color: #3A62D7;
          &:hover{
            cursor: pointer;
          }
        }


      }

      .btnContainer{
        width:100%;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 13px;
        margin-top: 20px;
        button{
          margin: 0 15px;
        }
      }
    }
    ::v-deep{

      .el-dialog__header {
        padding: 9px 20px 9px;
        background: #335483;
      }

      .el-dialog__title {
        line-height: 24px;
        font-size: 14px;
        color: #FFFFFF;
      }

      .el-dialog__headerbtn {
        top: 9px;
      }

      .el-dialog__headerbtn .el-dialog__close {
        color: #fff;
        font-size: 25px;
      }

      .el-dialog__body {
        padding: 0;
        overflow: auto;
        max-height: 75vh;
        color: #606266;
      }

    }

  }

</style>
